<div class="kop">
	<a class="logo" routerLink="/">
		@if (ingeklapt()) {
			<img src="/assets/img/CumLaude-icon.svg" alt="CumLaude" />
		} @else {
			<img src="/assets/img/CumLaude.svg" alt="CumLaude" />
		}
	</a>
</div>

<div class="scrollgebied">
	<a class="rij vast" [class.actief]="startActief()" [routerLink]="startUrl()">
		<app-icon name="startpagina" size="medium" [color]="startActief() ? 'primary-1' : 'typography-1'"></app-icon>
		<span class="titel" [class.sr-only]="ingeklapt()">{{ startTitel() }}</span>
	</a>
	@if (nav.sectie() === "dashboards") {
		<button type="button" class="rij vast" [class.open]="favorietenOpen()" (click)="openFavorieten()">
			<app-icon name="bookmark-outline" size="medium" color="typography-1"></app-icon>
			<span class="titel" [class.sr-only]="ingeklapt()">Favorieten</span>
			@if (!ingeklapt()) {
				<app-icon name="chevron-right" size="smallest" color="typography-5"></app-icon>
			}
		</button>
	}

	<div class="scheiding"></div>

	@if (!ingeklapt()) {
		<div class="sectie-kop">
			<span>{{ nav.sectie() === "beheer" ? "Beheer" : "Dashboards" }}</span>
			@if (nav.magAllesDichtklappen()) {
				<button type="button" class="alles-dichtklappen" (click)="uitklap.allesDichtklappen()">Alles dichtklappen</button>
			}
		</div>
	}

	@for (rij of rijen(); track rij.item.url) {
		<app-navigatie-rij
			[rij]="rij"
			[ingeklapt]="ingeklapt()"
			(chevronGeklikt)="uitklap.toggle($event)"
			(titelMetChildrenGeklikt)="uitklap.zetIngeklapt(false)"
		></app-navigatie-rij>
	}
</div>

<button
	type="button"
	class="rij vast inklappen"
	[appTooltip]="ingeklapt() ? 'Uitklappen' : undefined"
	tooltipPosition="right"
	(click)="uitklap.toggleIngeklapt()"
>
	<app-icon [name]="ingeklapt() ? 'uitklappen-rechts' : 'uitklappen-links'" size="small" color="typography-1"></app-icon>
	@if (ingeklapt()) {
		<span class="sr-only">Uitklappen</span>
	} @else {
		<span class="titel">Inklappen</span>
	}
</button>
